import React from 'react';
import HvSvg from 'src/components/HvSvg';
import constants from 'src/constants';
import designSidebarUtils from 'src/utils/designSidebarUtils';

import {
  StyleAttributeImageIcon,
  StyleAttributeEditorIcon,
  StyleAttributeImage,
} from './styled';

const { generateThumbnailURL } = designSidebarUtils;

const ElementStyleAttributeEditor = ({
  color,
  imageUrl,
  id,
  attribute,
  available,
}) => {
  const AVAILABLE_ICON_PATH = require('src/assets/images/ic-plus.svg');
  const UNAVAILABLE_ICON_PATH = require('src/assets/images/ic-noedit.svg');
  const EDIT_ICON_PATH = require('src/assets/images/edit.svg');
  const isProductAttribute =
    attribute.property === constants.app.PRODUCT_ATTRIBUTE_PROPERTY;

  let src;
  if (id) {
    src = EDIT_ICON_PATH;
  } else {
    src = available ? AVAILABLE_ICON_PATH : UNAVAILABLE_ICON_PATH;
  }

  return id ? (
    <StyleAttributeImage
      imageUrl={generateThumbnailURL(imageUrl)}
      color={color}
      isProductAttribute={isProductAttribute}
    >
      <StyleAttributeImageIcon>
        <HvSvg src={src} />
      </StyleAttributeImageIcon>
    </StyleAttributeImage>
  ) : (
    <StyleAttributeEditorIcon disabled={!available}>
      <HvSvg src={src} />
    </StyleAttributeEditorIcon>
  );
};

export default ElementStyleAttributeEditor;
